import React, {useRef, useState} from 'react';
import styled from 'styled-components'
import { Wrapper } from '../../containers/Wrapper'
import Image from './Image'
import TextColumn from './TextColumn'
import Background from '../../../../assets/img/bg/bottombg02@2x.png'
import useElementInertialParallax from '../../../hooks/useElementInertialParallax'

const GridContainer = styled(Wrapper)`
    position: relative;
`

const BackgroundContainer = styled.div`
    position: absolute;
    z-index: 2;
    top: 20%;
    left: 0;

    img {
        width: 50%;
    }
`;

const ImagesContainer = styled.div`
    position: relative;
    width:110%;
`

const Container = styled.div`
    z-index: 1000;
    padding: 50px 0;

    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        padding: 15px 0;
    }
`

const TopContainer = styled(Container)`
    display: flex;
    align-items: start;

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        flex-direction: column;
    }
`;

const BottomContainer = styled(Container)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        grid-template-columns: 1fr;
        padding: 15px 0;
    }
`;

const Photo = styled.img`
    z-index: 200;
    position: relative;
    width: 40%;
    margin-top: -25%;
    margin-left: 65%;

    @media (max-width: 1280px){
        z-index: 200;
        position: relative;
        width: 33%;
        margin-top: -23%;
        margin-left: 75%;
    }

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        display: none
    }
`

const TopImageText = (props) => {
    let photoSource = props.photoSource;
    const parallaxElement = useRef(null)
    const [parallaxOffset, setParallaxOffset] = useState(0)

    useElementInertialParallax((parallaxValue) => {
        setParallaxOffset(-10 + parallaxValue * 20)
    }, parallaxElement)

    return (
        <GridContainer>
            <BackgroundContainer ref={parallaxElement}>
                <img src={Background} style={ { transform: `translate3d(0,${parallaxOffset}%,0)` } }></img>
            </BackgroundContainer>
            <TopContainer>
                <ImagesContainer>
                    <Image width="100%" imageSource={props.image1Src} refContent={props.image1Ref}></Image>
                    <Photo src={require(`../../../../assets/img/Stock_images/${photoSource}`).default}></Photo>
                </ImagesContainer>
                <TextColumn content={props.text1} maxWidth="45%"></TextColumn>
            </TopContainer>
            <BottomContainer>
                <Image width="80%" imageSource={props.image2Src} refContent={props.image2Ref}></Image>
                <Image width="110%" imageSource={props.image3Src} refContent={props.image3Ref}></Image>
            </BottomContainer>
        </GridContainer>
    );
};

export default TopImageText;